module.exports = __webpack_public_path__ + "e7d53036d816a379399c818425b212ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/t_mobile_usa_2023_chart.png
// module id = 1742
// module chunks = 0